import React from 'react';
import { Item } from '../item';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import './highlightedpanel.scss';

export function HighlightedPanel(props) {
    const item = props.item;
    const subItems = item.items || [];
    const cmsOption = props.cmsOption || {};
    const bgColor = cmsUtils.payload(item, "BgColor");
    const imageUrl = cmsUtils.payload(item, "ImageUrl");
    const backgroundTile = cmsUtils.payload(item, "BackgroundTile");

    let bgUrl = null;
    if (imageUrl) bgUrl = utils.site.resourcePath(imageUrl);
    else if (backgroundTile)
        bgUrl = utils.site.resourcePath(
            `/dist/transparent-textures/textures/${backgroundTile}`
        );

    const cssClass = utils.classNames('cms_item', 'highlightedPanel__container', item.cssClass || item.anchorName || '');

    const subItemsElts = subItems.map((subItem, index) =>
        <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
    );

    return (
        <section
            className={cssClass}
            style={{
                backgroundColor: `${bgColor}`,
                backgroundImage: bgUrl && utils.css.bgUrlStyle(bgUrl),
                backgroundSize: '100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'repeat',
            }}
            data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
            id={item.anchorName}
        >
            <div className="highlightedPanel">
                {subItemsElts}
            </div>

        </section>

    );

}